import { useMutation } from '../../utils/error-handling/apollo-hooks-wrappers/custom-apollo-hooks';
import {
    MetadataType,
    ResetChecklistItemsDocument,
    ResetChecklistItemsMutation,
    ResetChecklistItemsMutationVariables,
    UpdateSetupStateDocument,
    UpdateSetupStateMutation,
    UpdateSetupStateMutationVariables,
    useGetSetupStateLazyQuery as _useGetSetupStateLazyQuery,
    useGetSetupStateQuery as _useGetSetupStateQuery,
    useUpdateFreeTrialOnboardingConfigMutation as _useUpdateFreeTrialOnboardingConfigMutation,
} from '../generated/graphql-types';

export const useGetSetupState = () => {
    const { data, error, loading } = _useGetSetupStateQuery({
        fetchPolicy: 'network-only',
    });

    return {
        error,
        loading,
        data: data?.getSetupState,
    };
};

export const useGetSetupStateLazyQuery = () => {
    const [
        getSetupState,
        { data, error, loading },
    ] = _useGetSetupStateLazyQuery({
        fetchPolicy: 'network-only',
    });

    return {
        getSetupState,
        error,
        loading,
        data: data?.getSetupState,
    };
};

export const useUpdateSetupStateMutation = () => {
    const [updateSetupState, { data, error, loading }] = useMutation<
        UpdateSetupStateMutation,
        UpdateSetupStateMutationVariables
    >(UpdateSetupStateDocument);

    return {
        data: data?.Onboarding__updateSetupState,
        error,
        loading,
        updateSetupState: (type: MetadataType, dataSourceId: string) =>
            updateSetupState({
                variables: {
                    type,
                    dataSourceId,
                },
            }),
    };
};

export const useUpdateFreeTrialOnboardingConfigMutation = () => {
    const [
        Session__updateFreeTrialOnboardingConfig,
        { data, error, loading },
    ] = _useUpdateFreeTrialOnboardingConfigMutation();

    return {
        data: data?.Session__updateFreeTrialOnboardingConfig,
        error,
        loading,
        updateFreeTrialOnboardingConfig: (
            freeTrialOnboardingSeen: boolean,
            onboardingLocationSelected: string,
            edgeOnboardingCompleted: boolean,
        ) =>
            Session__updateFreeTrialOnboardingConfig({
                variables: {
                    freeTrialOnboardingSeen,
                    onboardingLocationSelected,
                    edgeOnboardingCompleted,
                },
            }),
    };
};

export const useResetChecklistItems = () => {
    const [resetChecklistItems, { data, error, loading }] = useMutation<
        ResetChecklistItemsMutation,
        ResetChecklistItemsMutationVariables
    >(ResetChecklistItemsDocument);
    return {
        data: data?.resetChecklistItems,
        error,
        loading,
        resetChecklistItems: () => resetChecklistItems({}),
    };
};
